const LOGO_RATIO = 336 / 77;

/** Corporate lockup: the Odingard emblem and wordmark artwork. */
export function OdingardLogo({ height = 30 }: { height?: number }) {
  return (
    <span className="logo">
      <img
        src="/brand/odingard-logo.png"
        alt="Odingard"
        width={Math.round(height * LOGO_RATIO)}
        height={height}
      />
    </span>
  );
}

/** The Odingard emblem alone, in currentColor: shield and interlocked triangles. */
export function OdingardMark({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path d="M5 10.5 32 4.5l27 6-4 37L32 59.5 9 47.5z" strokeWidth={4.5} />
      <path
        d="M26.5 18 17 35h19z M33.5 18 24 35h19z M30 26 20 42.5h20z"
        strokeWidth={3.2}
      />
    </svg>
  );
}
